$(document).ready(function() {


    // #############################################
    //Form Validation :::
    $('.validate-form').each(function() {
        $(this).validate({
            submitHandler: function(form) {
                form.submit();
            },
            rules: {
                required: true
            },
            errorPlacement: function(error, element) {

                if(element[0].type === 'checkbox') {
                    this.findByName(element[0].name).parents('.row').after(error);
                } else {
                    error.insertAfter(element);
                }
            },
            highlight: function(element, errorClass, validClass) {
                if (element.type === 'radio') {
                    this.findByName(element.name).parents('.row').addClass(errorClass).removeClass(validClass);
                } else {
                    $(element).parents('.row').addClass(errorClass).removeClass(validClass);
                }
            },
            unhighlight: function(element, errorClass, validClass) {
                if (element.type === 'radio') {
                    this.findByName(element.name).parents('.row').removeClass(errorClass).addClass(validClass);
                } else {
                    $(element).parents('.row').removeClass(errorClass).addClass(validClass);
                }
            }
        });
    });


    // #############################################
    //Custom Select Dropdown && Multiselect :::
    //$('.custom-select-dropdown').SumoSelect();

    // reload native select after changing option
    $('.SumoSelect .optWrapper li').click(function(event) {
        event.stopPropagation();
        $('select.custom-select-dropdown')[0].sumo.reload();
    });


    // #############################################
    //Lightbox Initiations ::::
    $('.open-popup-link').magnificPopup({
        type:'inline',
        showCloseBtn: true,
        closeOnBgClick: true,
        removalDelay: 300,
        mainClass: 'mfp-zoom-in',
        midClick: true
    });

    $('.lightbox-manual-close-trigger').click(function(event) {
        e.preventDefault();
        $.magnificPopup.close();
    });

    // #############################################
    // TABS

    $('.js-tab-triggers a').on('click', function(e) {
        e.preventDefault();
        $('.js-tab-triggers a').not(this).removeClass('active');
        $(this).addClass('active');
        var getTarget = $(this).attr('href');
        $('.tab-content').not(getTarget).hide();
        $(getTarget).show();
    });


    // #############################################
    //ISOTOPE MASONRY

    // var $container = $('.masonry-module').isotope({
    //     itemSelector: '.list',
    //     columnWidth: 3,
    //     layoutMode : 'masonry'
    // });

    // #############################################
    //Read More Toggle

    var step = 0;

    $(".js-increase-font-size").click(function (event) {
        event.preventDefault();
        if(step < 4) {
            /*$("h1, h2, h3, h4, h5, p, span, a, ul, ol, li, article, label").each(function (e) {
                var fontSize = $(this).css('font-size');
                fontSize = parseInt(fontSize) + 1;
                fontSize = fontSize + 'px';
                $(this).css('font-size', fontSize);
            });*/

            $("body").each(function (e) {
                var fontSize = $(this).css('font-size');
                fontSize = parseInt(fontSize) + 2;
                fontSize = fontSize + 'px';
                $(this).css('font-size', fontSize);
            });

            step ++;
        }
    });

    $(".js-decrease-font-size").click(function (event) {
        event.preventDefault();
        if(step > 0) {
            /*$("h1, h2, h3, h4, h5, p, span, a, ul, ol, li, article, label").each(function (e) {
                var fontSize = $(this).css('font-size');
                fontSize = parseInt(fontSize) - 1;
                if(fontSize < 1) {
                    fontSize = 1;
                }
                fontSize = fontSize + 'px';
                $(this).css('font-size', fontSize);
            });*/

            $("body").each(function (e) {
                var fontSize = $(this).css('font-size');
                fontSize = parseInt(fontSize) - 2;
                if(fontSize < 1) {
                    fontSize = 1;
                }
                fontSize = fontSize + 'px';
                $(this).css('font-size', fontSize);
            });

            step --;
        }

    });

    $("#scroll-down").click(function(e) {
        $('html, body').animate({scrollTop: $('#info-section').offset().top},'slow');
    });

});


// Function: captureSumoSelectValue ()
// Param: field - the field being captured
// Capture sumo select value (required only)
function captureSumoSelectValue(field) {
    var sumoSelectedItem = '';
    sumoSelectedItem = $(field).find('.selected').attr('data-val');
    return sumoSelectedItem;
}

$.fn.toggleHTML = function(t1, t2) {
    if (this.html() == t1) this.html(t2);
    else this.html(t1);
    return this;
};


// #############################################
//Main Menu ::: 
function slideMenu(action){ 
    var $menu = $('#mobile-menu') 
    if (!action) { toggle(); return }
    if (action == "open") { open(); return }
    if (action == "close") { close(); return }

    function open(){
        $("body").addClass('open-menu');
        $menu.attr('status', 'open');
    }
    function close(){
        $("body").removeClass('open-menu');
        $menu.attr('status', 'closed');
    }
    function toggle(){
        var status =  $menu.attr('status');
        if (status == "open"){ close(); return }
        if (status == "closed"){ open(); return }
    }
}

$('#mobile-menu li').each(function(){
        $(this).has("ul").addClass('mobile-menu-parent');
});

$( ".mobile-menu-parent .icon" ).on("click", function(){
    $(this).siblings('ul').slideToggle(150);
});

//prevent slide up
$(".mobile-menu-parent").on("click", "ul", function(event){
    event.stopPropagation()
})

// #############################################
// Header Highlighter :::
// By David - functionality af
$(document).ready(function() {
    var headerHref = "#site-header";
    var mobileHref = "#mobile-menu";
    var myURL = "/" + location.pathname.split('/')[1];

    $(headerHref + ' li').each(function(){
        if ($(this).find('a').attr('href') == myURL) {
            $(this).find('a').addClass("selected")
            return
        }
    })

    $(mobileHref + ' li').each(function(){
        if ($(this).find('a').attr('href') == myURL) {
            $(this).find('a').addClass("selected")
            return
        }
    })
});



